/** KAN-736: address of the full-page conversation of a client ("Широкий вид"). */
export function contactChatPath(clientId: string): string {
  return `/clients/${clientId}/chat`
}
